import React, { useState } from 'react';
import './shared.css';

const Accordion = ({ title = 'Details', children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  
  return (
    <div className={`accordion ${open ? 'open' : ''}`}>
      <button className="accordion-header" onClick={() => setOpen(!open)}>
        <span>{title}</span>
        <span className="accordion-icon">{open ? '−' : '+'}</span>
      </button>
      {open && <div className="accordion-content">{children}</div>}
    </div>
  );
};

export default Accordion;
